module.exports = __webpack_public_path__ + "static/media/mision.7164dfa8.png";